import { createFileRoute } from "@tanstack/react-router";
import { IndustryDetailPage } from "@/components/site/IndustryDetailPage";
import { industryDetails } from "@/lib/industry-details";
import {
  generateServiceSchema,
  generateFaqSchema,
  generateBreadcrumbSchema,
} from "@/components/site/Schema";

const data = industryDetails["saas"]!;

export const Route = createFileRoute("/industries/saas")({
  head: () => ({
    meta: [
      { title: data.metaTitle },
      { name: "description", content: data.metaDescription },
      { property: "og:title", content: data.metaTitle },
      { property: "og:description", content: data.metaDescription },
      { property: "og:url", content: "https://finendra.com/industries/saas" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: data.metaTitle },
      { name: "twitter:description", content: data.metaDescription },
    ],
    links: [{ rel: "canonical", href: "https://finendra.com/industries/saas" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateServiceSchema({
            name: "SaaS Bookkeeping & Accounting Operations",
            description: data.metaDescription,
            url: "https://finendra.com/industries/saas",
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateBreadcrumbSchema([
            { name: "Home", url: "https://finendra.com" },
            { name: "Industries", url: "https://finendra.com/industries" },
            { name: "SaaS & Technology", url: "https://finendra.com/industries/saas" },
          ]),
        ),
      },
    ],
  }),
  component: () => <IndustryDetailPage data={data} />,
});
